require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-bs-blueprintjs-core.json") })
        }
      }, "path---package-bs-blueprintjs-core");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-bs-blueprintjs-core!./.cache/json/package-bs-blueprintjs-core.json
// module id = 760
// module chunks = 231608221292675